import { Injectable } from '@angular/core'

class NavigationState {
  navigationId: string
  route: string
  trigger: string

  constructor(navigationId, route, trigger) {
    this.navigationId = navigationId
    this.route = route
    this.trigger = trigger
  }
}

@Injectable({
  providedIn: 'root'
})
export class PageNavigationService {

  currentState: NavigationState
  prevState: NavigationState
  openNow: boolean
  modalRestore: boolean
  modalRestoreExternal: boolean

  constructor() { }

  writeNewState(navigationId, route, trigger) {
    this.prevState = this.currentState
    this.currentState = new NavigationState(navigationId, route, trigger)
  }

  getCurrentState(): NavigationState {
    return this.currentState
  }

  getPrevState(): NavigationState {
    return this.prevState
  }

}
